import { useState } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import AuthInfoObj from "../../ApiServices/AuthInfoObj";
import { APPID, DOMAIN_NAME, VERSION, REFERER } from "../../Config.js";
import toast from "react-hot-toast";

const TransactionReportService = () => {
  const [balanceData, setBalanceData] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [transactionReportData, setTransactionReportData] = useState();
  const [searchInputs, setSearchInputs] = useState({
    accountNo: "",
    transactionID: "",
    status: "",
    tid: "",
  });
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const getToday = () => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  };

  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());
  const [actionDropdown, setActionDropdown] = useState(null);
  const [showReceiptPopup, setShowReceiptPopup] = useState(false);
  const [showComplaintPopup, setShowComplaintPopup] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const formatDateForAPI = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const toggleSearch = () => {
    setShowSearch((prev) => !prev);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  const getRechargeReport = async () => {
    try {
      setLoading(true);
      const bodyObject = {
        apiid: 0,
        criteriaID: 0,
        isExport: false,
        isRecent: false,
        topRows: 100,
        oid: 0,
        tid: Number(searchInputs?.tid) || 0,
        opTypeID: 0,
        status: Number(searchInputs?.status) || 0,
        accountNo: searchInputs?.accountNo,
        transactionID: searchInputs?.transactionID || "",
        fromDate: formatDateForAPI(fromDate),
        toDate: formatDateForAPI(toDate),
      };
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/RechargeReport",
        data: bodyObject,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.statuscode === 1) {
        setTransactionReportData(res?.rechargeReport);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getRechargeReport :", error);
    } finally {
      setLoading(false);
    }
  };
  const handlePrint = () => {
    window.print();
  };

  const submitComplaint = async () => {
    try {
      const payload = {
        isResend: false,
        loginTypeID: 0,
        otp: "",
        tid: selectedTransaction?.tid,
        transactionID: selectedTransaction?.transactionID,
      };

      const response = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/RefundRequest",
        data: payload,
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (response.statuscode === 1) {
        setShowComplaintPopup(false);
        getRechargeReport();
        toast.success(response.msg);
      } else {
        toast.error(response.msg);
      }
    } catch (error) {
      console.log("Complaint API Error:", error);
    }
  };

  return {
    getBalanceUser,
    balanceData,
    toggleSearch,
    showSearch,
    toDate,
    setToDate,
    fromDate,
    setFromDate,
    getRechargeReport,
    handleInputChange,
    searchInputs,
    transactionReportData,
    loading,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    handlePrint,
    submitComplaint,
    actionDropdown,
    setActionDropdown,
    showReceiptPopup,
    setShowReceiptPopup,
    showComplaintPopup,
    setShowComplaintPopup,
    selectedTransaction,
    setSelectedTransaction,
  };
};

export default TransactionReportService;
